import { reactive } from 'vue'
import actions from '@/store/notebook/actions'
import state from '@/store/notebook/state'
import getters from '@/store/notebook/getters'

export const notebookModule = {
    state: reactive(state),
    actions,
    getters,
}
